import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import * as XLSX from "xlsx";
import { ApiGetAllPeriodos } from "../../../api/periodos";
import { ApiGetAllComidas } from "../../../api/comidas";
import {
  ApiEstadoTicket,
  ApiGetAllTicketsWithDate,
  ApiGetAllTicketsWithDatePage,
  ApiGetTotalTicketWithDates,
} from "../../../api/tickets";
import ModalDefault from "../../../components/modalDefault";
import { contarTotalesPorRangoDesdeTexto } from "../../../utils/contadorDate";
import { buildCodigoReporte } from "../../../utils/date";
import Consolidados from "./consolidados";
import "./index.css";
import ModalRecuentos from "./ModalRecuentos";
import Pagination from "./paginacion";
import {
  buildTotalTicketsPDFBlob,
  downloadFromSignedUrl,
  exportTotalTicketsPDF,
  getFilenameFromKey,
} from "../../../utils/exportFiles";
import ModalInactivos from "./ModalInactivos";
import { uploadFile } from "../../../api/s3/presigned";
import {
  ApiGetReporteByPeriodo,
  ApiGuardarReportePeriodo,
} from "../../../api/reportes";
import { ApiDescargaFile } from "../../../api/presigned";
dayjs.extend(isSameOrBefore);

const Reportes = () => {
  const [rol, setRol] = React.useState(null);
  const [progress, setProgress] = useState({
    status: false,
    progress: 0,
  });

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("datauser"));
    setRol(data?.roles.code);
  }, []);

  const [state, setState] = useState({
    pre_periodo_id: "",
  });

  const [dateFilter, setDateFilter] = useState([
    // dayjs().subtract(1, "month").toDate(),
    dayjs().toDate(),
    dayjs().toDate(),
  ]);

  const [timeFilter, setTimeFilter] = useState(["", ""]);

  const [periodos, setPeriodos] = useState([]);
  const [comidas, setComidas] = useState([]);
  const [comidasT, setComidasT] = useState([]);
  const [comidasCustom, setComidasCustom] = useState([]);
  const [comidasDisponibles, setComidasDisponibles] = useState([]);
  const [comidaSelect, setComidaSelect] = useState("");
  const [comidasCustomPagesSize, setComidasCustomPagesSize] = useState(10);
  const [comidasFiltered, setComidasFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDisableDate, setIsDisableDate] = useState(false);
  const [queryEstado, setQueryEstado] = useState("");
  const [cumpleanerosCount, setCumpleanerosCount] = useState(0);
  const [showCumpleanero, setShowCumpleanero] = useState(false);

  const [inputSet, setInputSet] = useState({
    id: "selected",
    selected: ["TODOS"],
  });

  const [showModal, setShowModal] = useState(false);
  const [selectReporte, setSelectReporte] = useState({});

  const [page, setPage] = useState(1);
  const [porcent, setPorcent] = useState(0);
  const [pageSize, setPageSize] = useState(600);

  const [totalPage, settotalPage] = useState(0);
  const [total, settotal] = useState(0);

  const [showResumen, setShowResumen] = useState(false); // abre/cierra el modal
  const [showInactivos, setShowInactivos] = useState(false); // abre/cierra el modal
  const [resumenData, setResumenData] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [resumenInactivos, setResumenInactivos] = useState([]);

  const [reportPeriodo, setReportPeriodo] = useState(null);
  const [regenLoading, setRegenLoading] = useState(false);

  const formatGuayaquil = (d) =>
    d ? dayjs(d).tz("America/Guayaquil").format("DD/MM/YYYY") : "";

  const ProgressBar = (percentage) => {
    return (
      <div className="progress-bar-container w-50">
        <div className="progress-bar" style={{ width: `${percentage}%` }}>
          {percentage}%
        </div>
      </div>
    );
  };

  const fetchReportPdf = useCallback(async () => {
    if (!state.pre_periodo_id) return;

    try {
      const res = await ApiGetReporteByPeriodo({
        pre_periodo_id: state.pre_periodo_id,
        tipo: "CONSOLIDADO",
      });
      if (res.sms === "ok") {
        setReportPeriodo(res.data);
      } else {
        setReportPeriodo(null);
      }
    } catch (error) {
      console.error("Error generating PDF report:", error);
    }
  }, [state.pre_periodo_id]);

  useEffect(() => {
    fetchReportPdf();
  }, [fetchReportPdf]);

  useEffect(() => {
    setIsDisableDate(state.pre_periodo_id !== "" ? true : false);
    if (state.pre_periodo_id !== "") {
      const periodo = periodos.find(
        (p) => p.pre_periodo_id === parseInt(state.pre_periodo_id)
      );
      const inicio = dayjs(periodo.fecha_inicio).toDate();
      const fin = dayjs(periodo.fecha_fin).toDate();
      setDateFilter([inicio, fin]);
    }
  }, [state]);

  const getPeriodoFn = async () => {
    const [resPeriodos, resComidas] = await Promise.all([
      ApiGetAllPeriodos(),
      ApiGetAllComidas(),
    ]);
    if (resPeriodos.sms === "ok") setPeriodos(resPeriodos.data);
    if (resComidas.sms === "ok") {
      setComidasDisponibles(
        (resComidas.data || [])
          .filter((c) => c?.estado !== false)
          .map((c) => (c?.nombre || "").toString().trim())
          .filter(Boolean)
      );
    }
  };

  const init2 = async () => {
    setLoading(true);
    setPorcent(0);
    const inicio = timeFilter[0]
      ? `${dayjs(dateFilter[0]).format("DD-MM-YYYY")} ${timeFilter[0]}`
      : dayjs(dateFilter[0]).format("DD-MM-YYYY");
    const fin = timeFilter[1]
      ? `${dayjs(dateFilter[1]).format("DD-MM-YYYY")} ${timeFilter[1]}`
      : dayjs(dateFilter[1]).format("DD-MM-YYYY");
    const resTotal = await ApiGetTotalTicketWithDates(inicio, fin);
    settotal(resTotal.data);
    let totaldata = [];
    let totalDataPorPagina = [];
    const totalPaginas = Math.ceil(resTotal.data / pageSize);
    settotalPage(totalPage);
    if (totalPaginas > 0) {
      for (let x = 1; x <= parseInt(totalPaginas); x++) {
        const res = await ApiGetAllTicketsWithDate(
          inicio,
          fin,
          x,
          pageSize,
          resTotal.data,
          totalPaginas
        );
        if (res.sms === "ok") {
          totaldata = totaldata.concat(res.data.tickets);
          totalDataPorPagina.push(res.data);
          const porcent = Math.round((totaldata.length * 100) / resTotal.data);
          setPorcent(porcent);
        } else {
        }
      }
      console.log("Listado de paginas de la data");
      console.log(totalDataPorPagina);
      setComidasFiltered(totaldata);
      setComidas(totaldata);
      totaldata = [];

      /* const Rangos = await ApiObtenerRangosSistema();
      if (Rangos.sms === "ok") {
        const tipos = Rangos.data.map((item) => {
          return { value: item.code, label: item.tipo };
        });
        const newTipos = [
          ...[
            { value: "TODOS", label: "TODOS" },
            { value: "T", label: "TRABAJADOR" },
            { value: "C", label: "CUADRILLA" },
          ],
          ...tipos,
        ];
        setOptions(newTipos);
      } */
    }

    setLoading(false);
    setComidasCustom(totaldata);
    setPage(1);
    setComidaSelect("");
  };

  const init = async () => {
    setLoading(true);
    setPorcent(0);

    const inicio = timeFilter[0]
      ? `${dayjs(dateFilter[0]).format("DD-MM-YYYY")} ${timeFilter[0]}`
      : dayjs(dateFilter[0]).format("DD-MM-YYYY");
    const fin = timeFilter[1]
      ? `${dayjs(dateFilter[1]).format("DD-MM-YYYY")} ${timeFilter[1]}`
      : dayjs(dateFilter[1]).format("DD-MM-YYYY");

    const resTotal = await ApiGetTotalTicketWithDates(inicio, fin);
    const totalRegistros = resTotal.data;
    settotal(totalRegistros);

    const totalPaginas = Math.ceil(totalRegistros / pageSize);
    settotalPage(totalPaginas);

    const batchSize = 6; // Puedes subir a 20 o más si tu API lo soporta
    let totaldata = [];
    let currentPage = 1;

    while (currentPage <= totalPaginas) {
      const batch = [];

      for (
        let i = currentPage;
        i < currentPage + batchSize && i <= totalPaginas;
        i++
      ) {
        batch.push(
          ApiGetAllTicketsWithDate(
            inicio,
            fin,
            i,
            pageSize,
            totalRegistros,
            totalPaginas
          )
        );
      }

      try {
        const results = await Promise.all(batch);

        results.forEach((res) => {
          if (res.sms === "ok") {
            totaldata = totaldata.concat(res.data.tickets);
          }
        });

        const porcent = Math.round((totaldata.length * 100) / totalRegistros);
        setPorcent(porcent);
      } catch (err) {
        console.error("Error al procesar un lote:", err);
      }

      currentPage += batchSize;
    }

    setComidasFiltered(totaldata);
    setComidas(totaldata);
    let auxTotaldata = totaldata.filter(
      (data) =>
        !isCumpleanero(data) &&
        data.pre_usuarios.estado &&
        !data.pre_usuarios.eliminado
    );
    setComidasCustom(auxTotaldata);
    setPage(1);
    setComidaSelect("");
    setLoading(false);
  };

  useEffect(() => {
    getPeriodoFn();
    initPage();
  }, []);

  useEffect(() => {
    if (showCumpleanero) {
      setComidasCustom(comidas.filter((item) => isCumpleanero(item)));
    }
  }, [showCumpleanero]);

  const initPage = async () => {
    const inicio = timeFilter[0]
      ? `${dayjs(dateFilter[0]).format("DD-MM-YYYY")} ${timeFilter[0]}`
      : dayjs(dateFilter[0]).format("DD-MM-YYYY");
    const fin = timeFilter[1]
      ? `${dayjs(dateFilter[1]).format("DD-MM-YYYY")} ${timeFilter[1]}`
      : dayjs(dateFilter[1]).format("DD-MM-YYYY");

    const res = await ApiGetAllTicketsWithDatePage(
      inicio,
      fin,
      page,
      100,
      total,
      totalPage
    );
    if (res.sms === "ok") {
      setComidasT(res.data.tickets);
    } else {
    }
  };

  const filtrarTicketsUsuariosInactivos = (tickets) => {
    return tickets.filter((t) => {
      const u = t?.pre_usuarios;
      if (!u) return false;
      // Nota: si en tu API "estado" puede venir null/undefined, lo convertimos a boolean
      const activo = !!u.estado; // true si activo, false si inactivo
      const eliminado = !!u.eliminado; // true si eliminado
      return !activo || eliminado; // inactivo O eliminado
    });
  };

  const abrirModalInactivos = () => {
    const filtrados = filtrarTicketsUsuariosInactivos(comidas);
    const resumen = buildResumen(filtrados);
    setResumenInactivos(resumen);
    setShowInactivos(true);
  };

  /*  const{init = async () => {
    setLoading(true);
    const inicio = dayjs(dateFilter[0]).format("DD-MM-YYYY");
    const fin = dayjs(dateFilter[1]).format("DD-MM-YYYY");

    const res = await ApiGetAllTicketsWithDate(inicio, fin);

    if (res.sms === "ok") {
      setComidasFiltered(res.data.tickets);
      setComidas(res.data.tickets);
    } else {
    }
    setLoading(false);
  }; */

  const onchange = (e) => {
    e.preventDefault();
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const countCumpleanerosTickets = (tickets) => {
    let count = 0;

    tickets.forEach((ticket) => {
      const usuario = ticket.pre_usuarios;
      if (!usuario) return;

      const tipo = usuario.pre_tipos_usuarios?.tipo;
      const fechaNaci = usuario.fecha_naci;
      const createAt = dayjs(ticket.create_at).tz("America/Guayaquil");

      // Mantener filtro por tipo TRABAJADOR
      if (tipo !== "TRABAJADOR" || !fechaNaci) return;

      try {
        const [diaNac, mesNac] = fechaNaci.split("/").map(Number);
        const diaTicket = createAt.date();
        const mesTicket = createAt.month() + 1;

        // Si el ticket es de cumpleaños, lo contamos
        if (diaNac === diaTicket && mesNac === mesTicket) {
          count++;
        }
      } catch (error) {
        console.error("Error procesando fecha:", fechaNaci, error);
      }
    });

    return count;
  };

  const onUpdateEstado = async () => {
    const res = await ApiEstadoTicket({
      pre_ticket_id: selectReporte.pre_ticket_id,
      client_estado: "INCONPLETO",
    });
    if (res.sms === "err") {
      toast.success(res.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      return;
    }

    let rep = [...comidasFiltered];
    const index = rep.findIndex(
      (item) => item.pre_ticket_id === selectReporte.pre_ticket_id
    );
    rep[index].client_estado = "INCONPLETO";

    setComidasFiltered(rep);

    toast.success(res.mensaje, {
      position: "bottom-left",
      style: {
        border: "1px solid green",
        padding: "16px",
        color: "white",
        background: "green",
        borderColor: "white",
      },
      iconTheme: {
        primary: "green",
        secondary: "white",
      },
    });
    setShowModal(false);
  };

  const exportTotalsToPDF = () => {
    exportTotalTicketsPDF(comidas, dateFilter, comidasDisponibles);
  };

  const handleGenerarYSubirPDFConsolidado = async () => {
    setRegenLoading(true);
    try {
      if (!comidas || comidas.length === 0) {
        toast.error("No hay datos para generar el PDF");
        return;
      }

      setProgress({ status: true, progress: 0 });

      // 1) Generar PDF en memoria
      const { blob, filename } = buildTotalTicketsPDFBlob(
        comidas,
        dateFilter,
        comidasDisponibles
      );

      // 2) Convertir a File para tu helper de S3 (si tu helper acepta Blob, puedes pasar blob directamente)
      const pdfFile = new File([blob], filename, { type: "application/pdf" });

      // 3) Subir a S3 (usa tu helper existente con barra de progreso)
      //    Nota: tu uploadFile ya recibe (file, setProgress, carpeta)
      const uploadResult = await uploadFile(pdfFile, setProgress, "reportes");
      if (!uploadResult || !uploadResult.success) {
        throw new Error(uploadResult?.message || "No se pudo subir a S3");
      }

      // 4) Guardar/Regenerar en DB (SOLO si está seleccionado un periodo)
      if (!state.pre_periodo_id) {
        toast.success(
          "PDF subido a S3. Selecciona un período para guardarlo en la BD."
        );
        return;
      }

      // Obtén info del usuario actual si la tienes en localStorage
      const user = JSON.parse(localStorage.getItem("datauser") || "{}");
      const pre_usuario_id = user?.pre_usuario_id || user?.id || null;

      // Bucket/key desde el resultado; si tu helper no retorna bucket, usa una constante/env
      const s3_bucket =
        uploadResult.bucket ||
        process.env.NEXT_PUBLIC_S3_BUCKET ||
        "tu-bucket-default";
      const s3_key = uploadResult.key;

      // 5) Llamar a tu endpoint "createOrUpdate" (regenera = actualiza)
      const payload = {
        pre_periodo_id: parseInt(state.pre_periodo_id),
        tipo: "CONSOLIDADO",
        s3_bucket,
        s3_key,
        pre_usuario_id: pre_usuario_id ?? undefined,
        informacion_adicional: `Reporte consolidado de ${dayjs().format(
          "YYYY-MM-DD HH:mm:ss"
        )}`,
      };

      const resp = await ApiGuardarReportePeriodo(payload);
      if (resp.sms === "ok") {
        toast.success("Reporte guardado/regenerado correctamente.");
        const descarga = await ApiDescargaFile(resp.data.s3_key);
        if (descarga?.sms !== "ok") throw new Error(descarga.message);
        const url = descarga.data.url;
        const filename = getFilenameFromKey(resp.data.s3_key);
        await downloadFromSignedUrl(url, filename);
      } else {
        toast.error(resp?.mensaje || "No se pudo guardar el reporte en la BD.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error generando o subiendo el PDF.");
    } finally {
      setProgress({ status: false, progress: 0 });
      fetchReportPdf();
      setRegenLoading(false);
    }
  };

  const handleDownloadReporte = async () => {
    if (!reportPeriodo) {
      toast.error("No hay reporte disponible para el período seleccionado.");
      return;
    }
    try {
      const descarga = await ApiDescargaFile(reportPeriodo.s3_key);
      if (descarga?.sms !== "ok") throw new Error(descarga.message);
      const url = descarga.data.url;
      const filename = getFilenameFromKey(reportPeriodo.s3_key);
      await downloadFromSignedUrl(url, filename);
      toast.success("Reporte guardado/regenerado correctamente.");
    } catch (error) {
      console.error(error);
      toast.error("Error descargando el reporte.");
    }
  };

  const isCumpleanero = (ticket) => {
    const usuario = ticket.pre_usuarios;
    if (!usuario) return false;

    const fechaNaci = usuario.fecha_naci;
    const createAt = dayjs(ticket.create_at).tz("America/Guayaquil");

    if (usuario.pre_tipos_usuarios.tipo !== "TRABAJADOR" || !fechaNaci)
      return false;

    try {
      const [diaNac, mesNac] = fechaNaci.split("/").map(Number);
      const diaTicket = createAt.date();
      const mesTicket = createAt.month() + 1;

      return diaNac === diaTicket && mesNac === mesTicket;
    } catch (error) {
      return false;
    }
  };

  const exportToTxt = () => {
    setLoadingButton(true);
    let aux = comidas.filter(
      (data) =>
        data.client_estado === "CONFIRMADO" &&
        data.pre_usuarios.pre_tipos_usuarios &&
        data.pre_usuarios.pre_tipos_usuarios.tipo === "TRABAJADOR" &&
        !isCumpleanero(data) &&
        data.pre_usuarios.estado &&
        !data.pre_usuarios.eliminado
    );
    if (aux.length === 0) {
      alert("No hay registros confirmados para exportar");
      return;
    }
    let comidasCopy = aux;

    comidasCopy.sort((a, b) => {
      if (parseInt(a.pre_usuarios.code) < parseInt(b.pre_usuarios.code)) {
        return -1;
      }
      if (parseInt(a.pre_usuarios.code) > parseInt(b.pre_usuarios.code)) {
        return 1;
      }
      return 0;
    });

    let txt = "";
    comidasCopy.map((item) => {
      txt += buildCodigoReporte(item) + "\n";
    });

    const element = document.createElement("a");
    const file = new Blob([txt], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    alert(`Se descargará el reporte TXT de ${comidasCopy.length} registros\n
      ${contarTotalesPorRangoDesdeTexto(txt)}`);
    element.download = `reporte_comidas_${dayjs(dateFilter[0]).format(
      "YYYY-MM-DD"
    )}_${dayjs(dateFilter[1]).format("YYYY-MM-DD")}.txt`;
    document.body.appendChild(element);
    element.click();
    setLoadingButton(false);
  };

  const exportToExcel = () => {
    let total = 0;
    let auxComidasFiltered = comidasCustom.filter(
      (data) =>
        !isCumpleanero(data) &&
        data.pre_usuarios.estado &&
        !data.pre_usuarios.eliminado
    );
    const data = auxComidasFiltered.map((item) => {
      total += parseFloat(item.costo);
      if (rol === "5") {
        return {
          Codigo: `${
            item.pre_usuarios.code.length === 1
              ? `000${item.pre_usuarios.code}`
              : item.pre_usuarios.code.length === 2
              ? `00${item.pre_usuarios.code}`
              : item.pre_usuarios.code.length === 3
              ? `0${item.pre_usuarios.code}`
              : item.pre_usuarios.code
          }`,
          Tipo: item.pre_usuarios?.pre_tipos_usuarios?.tipo || "",
          Comida: item.comida,
        };
      } else {
        return {
          Periodo: item.pre_periodos.nombre,
          "Fecha y hora": dayjs(item.create_at)
            .tz("America/Guayaquil")
            .format("DD/MM/YYYY HH:mm"),
          "Codigo reporte": buildCodigoReporte(item),
          Identificacion: item.pre_usuarios.usuario,
          Apellidos: item.pre_usuarios.apellidos,
          Nombres: item.pre_usuarios.nombres,
          Tipo: item.pre_usuarios?.pre_tipos_usuarios?.tipo || "",
          "Codigo Trabajador": `${
            item.pre_usuarios.code.length === 1
              ? `000${item.pre_usuarios.code}`
              : item.pre_usuarios.code.length === 2
              ? `00${item.pre_usuarios.code}`
              : item.pre_usuarios.code.length === 3
              ? `0${item.pre_usuarios.code}`
              : item.pre_usuarios.code
          }`,
          Comida: item.comida,
          Costo: item.costo,
        };
      }
    });
    if (rol === "1") {
      data.push({
        Periodo: "",
        "Fecha y hora": "",
        "Codigo reporte": "",
        Identificacion: "",
        Apellidos: "",
        Nombres: "",
        Tipo: "",
        "Codigo Trabajador": "",
        Comida: "Total costo de comidas:",
        Costo: total,
      });
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte de comidas");
    XLSX.writeFile(
      wb,
      `reporte_comidas_${dayjs(dateFilter[0]).format("YYYY-MM-DD")}_${dayjs(
        dateFilter[1]
      ).format("YYYY-MM-DD")}.xlsx`
    );
  };

  const exportToExcelCumpleanero = () => {
    if (!showCumpleanero) return;
    let total = 0;
    const data = comidasCustom.map((item) => {
      total += parseFloat(item.costo);

      return {
        Periodo: item.pre_periodos.nombre,
        Fecha: dayjs(item.create_at)
          .tz("America/Guayaquil")
          .format("DD/MM/YYYY HH:mm"),
        "Codigo reporte": buildCodigoReporte(item),
        Apellidos: item.pre_usuarios.apellidos,
        Nombres: item.pre_usuarios.nombres,
        Codigo: `${
          item.pre_usuarios.code.length === 1
            ? `000${item.pre_usuarios.code}`
            : item.pre_usuarios.code.length === 2
            ? `00${item.pre_usuarios.code}`
            : item.pre_usuarios.code.length === 3
            ? `0${item.pre_usuarios.code}`
            : item.pre_usuarios.code
        }`,
        Comida: item.comida,
      };
    });
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte de comidas");
    XLSX.writeFile(
      wb,
      `reporte_comidas_cumpleaneros_${dayjs(dateFilter[0]).format(
        "YYYY-MM-DD"
      )}_${dayjs(dateFilter[1]).format("YYYY-MM-DD")}.xlsx`
    );
  };

  const exportToExcelRecuento = () => {
    const data = resumenData.map((item) => {
      return {
        Codigo: item.code,
        Cantidad: item.count,
      };
    });
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte de comidas");
    XLSX.writeFile(
      wb,
      `reporte_reconteo_${dayjs(dateFilter[0]).format("YYYY-MM-DD")}_${dayjs(
        dateFilter[1]
      ).format("YYYY-MM-DD")}.xlsx`
    );
  };

  const buildResumen = (tickets) => {
    const map = new Map();

    tickets.forEach((t) => {
      const code = t?.pre_usuarios?.code;
      if (!code) return;

      if (!map.has(code)) {
        map.set(code, {
          code,
          count: 0,
          sample: t,
          nombres: t.pre_usuarios.nombres + " " + t.pre_usuarios.apellidos,
        });
      }
      map.get(code).count += 1;
    });

    // lo devolvemos como array ordenado por código
    return Array.from(map.values()).sort(
      (a, b) => parseInt(a.code) - parseInt(b.code)
    );
  };

  const exportarRecuentoInactivosExcel = () => {
    const data = resumenInactivos.map((item) => ({
      Codigo: item.code,
      Usuario: item.nombres,
      Cantidad: item.count,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Recuento inactivos o eliminados");
    XLSX.writeFile(
      wb,
      `recuento_inactivos_eliminados_${dayjs(dateFilter[0]).format(
        "YYYY-MM-DD"
      )}_${dayjs(dateFilter[1]).format("YYYY-MM-DD")}.xlsx`
    );
  };

  return (
    <>
      <div className="p-3">
        <div className="row  mb-4">
          <div className="col-md-12 col-lg-12  w-100">
            <div
              className=" bg-white  border-0 borde-tarjeta"
              style={{ height: "auto" }}
            >
              <div className="card-body m-0 p-0">
                <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                  <div className="w-100  d-flex justify-content-between align-items-center px-3">
                    <h5 className=" negrita card-title">Reportes de Comidas</h5>
                    <div className="d-flex justify-content-between flex-row align-self-start">
                      <div className="d-flex justify-content-end ">
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => {}}
                          style={{ visibility: "hidden" }}
                        >
                          Boton
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row py-4 ">
                  <div className="col-md-5 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Periodos:</label>
                      <div className={"col-md-12 p-0 m-0"}>
                        <select
                          className="inputselect2 bordecompleto bordesombreado"
                          id="pre_periodo_id"
                          name="pre_periodo_id"
                          style={{ width: "100%" }}
                          onChange={onchange}
                          value={state.pre_periodo_id}
                        >
                          <option value="">Fecha personalizada...</option>
                          {periodos.map((item, index) => (
                            <option key={index} value={item.pre_periodo_id}>
                              {item.nombre}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Fecha inicio:</label>

                      <div className={"col-md-7 p-0 m-0"}>
                        <input
                          type="date"
                          value={dayjs(dateFilter[0]).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            const newStartDate = dayjs(e.target.value).toDate();
                            setDateFilter([newStartDate, dateFilter[1]]);
                          }}
                          className="inputselect2 bordecompleto bordesombreado"
                          disabled={isDisableDate}
                        />
                      </div>
                      <div className={"col-md-5 p-0 m-0 pl-1"}>
                        <input
                          type="time"
                          value={timeFilter[0]}
                          onChange={(e) => {
                            setTimeFilter([e.target.value, timeFilter[1]]);
                          }}
                          className="inputselect2 bordecompleto bordesombreado"
                          disabled={isDisableDate}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Fecha fin:</label>

                      <div className={"col-md-7 p-0 m-0"}>
                        <input
                          type="date"
                          value={dayjs(dateFilter[1]).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            const newEndDate = dayjs(e.target.value).toDate();
                            setDateFilter([dateFilter[0], newEndDate]);
                          }}
                          className="inputselect2 bordecompleto bordesombreado"
                          disabled={isDisableDate}
                        />
                      </div>
                      <div className={"col-md-5 p-0 m-0 pl-1"}>
                        <input
                          type="time"
                          value={timeFilter[1]}
                          onChange={(e) => {
                            setTimeFilter([timeFilter[0], e.target.value]);
                          }}
                          className="inputselect2 bordecompleto bordesombreado"
                          disabled={isDisableDate}
                        />
                      </div>
                    </div>
                  </div>
                  {/*  <div className="col-md-4 ">
                    <div className=" row">
                      <label className="x-0 py-2 negrita">Filtro tipos:</label>
                      <div className={"col-md-12 p-0 m-0"}>
                        <Select
                          isMulti
                          isDisabled={rol === "1" ? false : true}
                          placeholder="Seleccione tipos..."
                          noOptionsMessage={() => "No se encontraron tipos"}
                          components={animatedComponents}
                          options={options}
                          value={options.filter((option) =>
                            inputSet.selected.includes(option.value)
                          )}
                          onChange={(selected) => {
                            handleSelect(
                              selected.map((option) => option.value),
                              inputSet.id
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>*/}
                  <div className="col-md-1 d-flex justify-content-end align-items-end ">
                    <div className={"col-2 px-1 m-0 w-100"}>
                      <button
                        type=""
                        className="bg-btn-vet bordesombreado"
                        onClick={init}
                        style={{
                          height: "45px",
                          width: "100%",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {porcent < 100 ? (
          loading ? (
            <div className="w-100 d-flex justify-content-center align-items-center flex-column ">
              <div>Cargando {total} registros</div>
              <hr />
              {ProgressBar(porcent)}
            </div>
          ) : (
            <div>Seleccione un rango de fechas</div>
          )
        ) : (
          <div className="row py-3">
            {/*   <div className="col-md-12 ">
              <div className="w-100 d-flex flex-row justify-content-start align-items-center flex-column">
                <h5 style={{textAlign:"left"}} className="w-100 negrita">INFORME GENERAL</h5>
              </div>
              <hr className="w-100" />

            </div> */}
            {/*   <div className="col-md-12">
              <AgruparPedidos data={comidas}></AgruparPedidos>{" "}
            </div> */}
            <div className="col-md-12 ">
              <div className="w-100 d-flex justify-content-start align-items-center flex-column">
                <h5 className="w-100 negrita ">IINFORME DETALLADO</h5>
              </div>
              <hr className="w-100" />
            </div>
            <div className="col-md-12">
              <Consolidados
                data={comidas}
                getdata={(data, comida) => {
                  // Dentro de la función init, después de obtener los datos
                  const cumpleCount = countCumpleanerosTickets(data);
                  setCumpleanerosCount(cumpleCount);
                  setComidaSelect(comida);
                  let auxData = data.filter(
                    (item) =>
                      !isCumpleanero(item) &&
                      item.pre_usuarios.estado &&
                      !item.pre_usuarios.eliminado
                  );
                  setComidasCustom(auxData);
                }}
                showCumpleanero={showCumpleanero}
                setShowCumpleanero={setShowCumpleanero}
                cumpleanerosCount={cumpleanerosCount}
                rol={rol}
              ></Consolidados>
            </div>
            {(rol === "1" || rol === "5") && (
              <div className="row">
                <div className="col-md-12 mb-2">
                  {rol === "1" ? (
                    <>
                      <button
                        type="button"
                        className="bg-btn-vet bordesombreado my-2 mx-2"
                        onClick={() => {
                          exportToExcel();
                        }}
                      >
                        <i className="fas fa-file-excel mx-2"></i>
                        Exportar a Excel
                      </button>
                      <button
                        type="button"
                        className="bg-btn-vet bordesombreado my-2 mx-2"
                        onClick={() => {
                          exportToTxt();
                        }}
                      >
                        <i className="fas fa-file-text mx-2"></i>
                        Exportar TXT
                        {loadingButton && (
                          <span className="spinner-border spinner-border-sm mx-2"></span>
                        )}
                      </button>
                      {showCumpleanero && (
                        <button
                          type="button"
                          className="bg-btn-vet bordesombreado my-2 mx-2"
                          onClick={() => {
                            exportToExcelCumpleanero();
                          }}
                        >
                          <i className="fas fa-file-excel mx-2"></i>
                          Exportar a Excel Cumpleañeros
                        </button>
                      )}
                      <button
                        type="button"
                        className="bg-btn-vet bordesombreado my-2 mx-2"
                        onClick={abrirModalInactivos}
                        title="Ver únicamente tickets de usuarios inactivos o eliminados"
                      >
                        <i className="fas fa-user-slash mx-2"></i>
                        Ver Inactivos/Eliminados
                        <span className="badge bg-secondary mx-1">
                          {filtrarTicketsUsuariosInactivos(comidas).length}
                        </span>
                      </button>
                    </>
                  ) : null}
                  {/* {reportPeriodo ? (
                    <>
                      <div
                        className="btn-group my-2 mx-2"
                        role="group"
                        aria-label="Acciones PDF periodo"
                      >
                        <button
                          type="button"
                          className="bg-btn-vet bordesombreado d-flex align-items-center"
                          onClick={handleDownloadReporte}
                          disabled={regenLoading || progress.status}
                          title="Descargar PDF generado"
                        >
                          <i className="fas fa-file-pdf me-2"></i>
                          Descargar PDF generado el{" "}
                          <small className="ms-1">
                            {formatGuayaquil(
                              reportPeriodo?.updated_at ||
                                reportPeriodo?.create_at
                            )}
                          </small>
                        </button>

                        <button
                          type="button"
                          className="btn btn-light bordesombreado"
                          style={{ padding: "0.45rem 0.6rem" }}
                          onClick={handleGenerarYSubirPDFConsolidado}
                          disabled={regenLoading || progress.status}
                          aria-label="Volver a generar y subir PDF"
                          title="Volver a generar y subir PDF"
                        >
                          {regenLoading ? (
                            <span className="spinner-border spinner-border-sm" />
                          ) : (
                            <i className="fas fa-sync-alt"></i>
                          )}
                        </button>
                      </div>

                      {(regenLoading || progress.status) && (
                        <span className="badge bg-warning text-dark align-self-center ms-2">
                          {progress.status
                            ? `Subiendo ${progress.progress}%`
                            : "Regenerando..."}
                        </span>
                      )}
                    </>
                  ) : (
                    <div
                      className="btn-group my-2 mx-2"
                      role="group"
                      aria-label="Acciones PDF periodo"
                    >
                      <button
                        type="button"
                        className="bg-btn-vet bordesombreado my-2 mx-2 d-flex align-items-center"
                        onClick={handleGenerarYSubirPDFConsolidado}
                        disabled={progress.status}
                        title="Generar PDF y subir a S3 (sin descargar)"
                      >
                        {progress.status ? (
                          <span className="spinner-border spinner-border-sm me-2" />
                        ) : (
                          <i className="fas fa-file-pdf me-2"></i>
                        )}
                        Generar & subir PDF Consolidado
                      </button>

                      {progress.status && (
                        <span className="badge bg-warning text-dark align-self-center ms-2">
                          Subiendo {progress.progress}%
                        </span>
                      )}
                    </div>
                  )} */}
                  <button
                    type="button"
                    className="bg-btn-vet bordesombreado my-2 mx-2"
                    onClick={() => {
                      exportTotalsToPDF();
                    }}
                  >
                    <i className="fas fa-file-pdf mx-2"></i>
                    Exportar PDF
                  </button>
                  <button
                    type="button"
                    className="bg-btn-vet bordesombreado my-2 mx-2"
                    onClick={() => {
                      const resumen = buildResumen(comidasFiltered); // o el array que prefieras
                      setResumenData(resumen);
                      setShowResumen(true);
                    }}
                  >
                    <i className="fas fa-eye mx-2"></i>
                    Ver Recuento
                  </button>
                  {/* {comidaSelect && (
                    <button
                      type=""
                      className="bg-btn-vet bordesombreado my-2 mx-2"
                      onClick={() => {
                        exportToPDF();
                      }}
                    >
                      <i className="fas fa-file-pdf mx-2"></i>
                      Exportar PDF
                    </button>
                  )} */}
                </div>
                {rol === "1" && (
                  <div
                    className="col-md-12 mt-2 mb-3"
                    style={{
                      maxHeight: "350px",
                      overflowY: "none",
                      position: "relative",
                    }}
                  >
                    <Pagination
                      data={comidasCustom}
                      itemsPerPage={comidasCustomPagesSize}
                      rol={rol}
                      queryEstado={queryEstado}
                    ></Pagination>
                  </div>
                )}
              </div>
            )}
            <ModalDefault
              bandera={"confirmacion"}
              modal={showModal}
              size={"sm"}
              titulo={`Cambiar estado`}
              closeAction={() => {
                setShowModal(false);
                setSelectReporte({});
              }}
            >
              <div className="row py-4 ">
                <p>
                  ¿Esta seguro de cambiar esta orden de comida a estado
                  incompleto?
                </p>
              </div>
              <div className="d-flex justify-content-end flex-row align-self-start my-4">
                <button
                  type=""
                  onClick={() => {
                    setShowModal(false);
                    setSelectReporte({});
                  }}
                  className="bg-btn-vet-danger sombra mx-1"
                >
                  Cancelar
                </button>
                <button
                  type=""
                  onClick={onUpdateEstado}
                  className="bg-btn-vet sombra mx-1"
                >
                  <i className="fas fa-save"> Cambiar</i>
                </button>
              </div>
            </ModalDefault>
          </div>
        )}
      </div>
      {/* <ModalDefault
        modal={showResumen}
        size="lg"
        titulo="Recuento por trabajador"
        closeAction={() => setShowResumen(false)}
      >
        <div className="table-responsive" style={{ maxHeight: "400px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <input
              type="search"
              className="form-control w-50 my-2 mx-2"
              placeholder="Buscar por código..."
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const filteredData = buildResumen(comidasFiltered)?.filter(
                  (item) => item.code.toString().toLowerCase() === searchTerm
                );
                setResumenData(filteredData);
                if (searchTerm === "") {
                  setResumenData(buildResumen(comidasFiltered));
                }
              }}
            />
            <button
              type="button"
              className="bg-btn-vet bordesombreado my-2 mx-2 d-flex"
              onClick={() => {
                exportToExcelRecuento();
              }}
            >
              <i className="fas fa-file-excel mx-2"></i>
              Exportar Excel
            </button>
          </div>
          <table className="table table-striped table-bordered mb-0">
            <thead className="text-center">
              <tr>
                <th>Código Trabajador</th>
                <th>Cantidad Tickets</th>
                <th>Ejemplo Código Reporte</th>
              </tr>
            </thead>
            <tbody>
              {resumenData.map(({ code, count, sample }) => (
                <tr key={code}>
                  <td className="text-center">
                    {code.toString().padStart(4, "0")}
                  </td>

                  <td className="text-center">{count}</td>

                  <td className="text-center">
                    {`${code.toString().padStart(4, "0")}${dayjs(
                      sample.create_at
                    ).format("YYYYMMDDHHmmss")}4008`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ModalDefault> */}

      <ModalRecuentos
        showResumen={showResumen}
        setShowResumen={setShowResumen}
        comidasFiltered={comidasFiltered}
        buildResumen={buildResumen}
        exportToExcelRecuento={exportToExcelRecuento}
        setResumenData={setResumenData}
        resumenData={resumenData}
      />

      <ModalInactivos
        showResumen={showInactivos}
        setShowResumen={setShowInactivos}
        comidasFiltered={comidasFiltered}
        buildResumen={buildResumen}
        exportToExcelRecuento={exportarRecuentoInactivosExcel}
        setResumenData={setResumenInactivos}
        resumenData={resumenInactivos}
      />
    </>
  );
};

export default Reportes;
